/**
 * @fileoverview Spinner - Loading spinner component
 *
 * Purpose: Animated loading indicator
 * Dependencies: lucide-react
 * Used by: Loading states, async operations, buttons
 *
 * Features:
 * - Rotating animation
 * - Accessible (role="status", aria-label)
 * - Customizable size
 * - Works inline or standalone
 *
 * @example
 * <Spinner />
 *
 * @example
 * // Custom size
 * <Spinner className="h-8 w-8" />
 *
 * @example
 * // In button
 * <Button disabled>
 *   <Spinner className="mr-2" />
 *   Loading...
 * </Button>
 */

import { Loader2Icon } from "lucide-react";

import { cn } from "@/utils/misc";

function Spinner({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <Loader2Icon
      role="status"
      aria-label="Loading"
      className={cn("size-4 animate-spin", className)}
      {...props}
    />
  );
}

export { Spinner };
